import { render, staticRenderFns } from "./expertsIn.vue?vue&type=template&id=083b13b8&scoped=true"
import script from "./expertsIn.vue?vue&type=script&lang=js"
export * from "./expertsIn.vue?vue&type=script&lang=js"
import style0 from "./expertsIn.vue?vue&type=style&index=0&id=083b13b8&prod&lang=scss&scoped=true"
import style1 from "./expertsIn.vue?vue&type=style&index=1&id=083b13b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b13b8",
  null
  
)

export default component.exports